import { routerReducer } from 'react-router-redux';
import { combineReducers } from 'redux';
import { authReducer } from './auth';
import { notificationReducer } from './notification';
import { tasksReducer } from './tasks';
import { groupsReducer } from './groups'
import { confirmedGroupReducer } from './confirmed-group'
import { roomBrowseReducer } from './room-browse'
import { housingResultReducer } from './housing-result'
import { reducer as FormReducer } from 'redux-form'

export default combineReducers({
  auth: authReducer,
  form: FormReducer,
  groups: groupsReducer,
  confirmedGroup: confirmedGroupReducer,
  housingResult: housingResultReducer,
  roomBrowse: roomBrowseReducer,
  notification: notificationReducer,
  routing: routerReducer,
  tasks: tasksReducer
});



// WEBPACK FOOTER //
// ./src/core/reducers.js